if ($('.product-template').length > 0) {
    let bars    = $('.slideshow-bars');
    let count   = $('.product__media-list').children().length;

    for (let index = 1; index < count; index++) {
        bars.append($('<div class="bar" data-count="' + (index + 1) + '"></div>'))
    }

    $('.bar').click(function (e) { 
        e.preventDefault();

        $('.bar').removeClass('active');
        $(this).addClass('active');

        let index = $(this).attr('data-count');

        $('.thumbnail-list').find('[data-media-position="'+ index +'"]').find('button').trigger('click');
    });

    $('.thumbnail-list__item').click(function (e) { 
        let index = $(this).attr('data-media-position');    
        
        $('.bar').removeClass('active');
        bars.find('[data-count="'+ index +'"]').addClass('active');

        $('html, body').animate({
            scrollTop: $('.product').offset().top
        }, 500);
    });
}

